import React from 'react'
import PageTitle from '../../pagetitle/PageTitle'
import LeftBar from '../../leftbar/LeftBar'

export default function Odeme() {
  return (
    <>
      <PageTitle name="Ödeme Bilgileri"></PageTitle>
      <div class="container">
        <div class="singlePost my-4">
          <div class="row">
            <div class="col-md-9">
              <div class="post sponsor">
                <div class="column">
                  <h3 class="odeme">Ödeme Bilgileri</h3>
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <td><strong>Hesap Adı:</strong></td>
                        <td>Samsun Üniversitesi Döner Sermaye İşletme Müdürlüğü</td>
                      </tr>
                      <tr>
                        <td><strong>Banka Adı:</strong></td>
                        <td>Ziraat Bankası / 19 Mayıs Üniversitesi Samsun Şubesi</td>
                      </tr>
                      <tr>
                        <td><strong>Şube kodu:</strong></td>
                        <td>1479</td>
                      </tr>
                      <tr>
                        <td><strong>Hesap No:</strong></td>
                        <td>1479889133375001</td>
                      </tr>
                      <tr>
                        <td><strong>IBAN No:</strong></td>
                        <td>TR96 0001 0014 7988 9133 3750 01</td>
                      </tr>
                      <tr>
                        <td><strong>Swift Kodu:</strong></td>
                        <td>TCZBTR2A</td>
                      </tr>
                      <tr>
                        <td><strong>Vergi No:</strong></td>
                        <td>7420747679</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <LeftBar />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
